export var DimeExperience;
(function (DimeExperience) {
    DimeExperience["BuyButton"] = "buybutton";
    DimeExperience["InstallGoPremiumButton"] = "installbutton";
    DimeExperience["ShellGoPremiumButton"] = "gopremium";
    DimeExperience["PaidConsumerBenefitsButton"] = "paidconsumer-unity";
    DimeExperience["PremiumTemplates"] = "templates";
    DimeExperience["Fre"] = "fre";
    DimeExperience["WelcomeBadge"] = "welcomebadge";
    DimeExperience["Resubscribe"] = "renew";
})(DimeExperience || (DimeExperience = {}));
//# sourceMappingURL=dimeExperience.js.map